import { getBotpress } from './Botpress';
import { getOS } from 'shared/helpers/browserHelpers';

export function useCustomerSupport() {
  const updateUser = (email: string, name: string) => {
    if (email) {
      void getBotpress().then((botpress) => {
        botpress.on('webchat:ready', async () => {
          const user = await botpress.getUser();

          if (user.name !== name) {
            await botpress.restartConversation();
          }

          await botpress.updateUser({
            name,
            data: { name, email, platform: 'web_carrier_signup', os: getOS() },
          });
        });
      });
    }
  };

  const openBotpress = (message?: string) => {
    void getBotpress().then((botpress) => {
      botpress.open();
      if (message) {
        botpress.sendMessage(message);
      }
    });
  };

  const closeBotpress = () => {
    void getBotpress().then((botpress) => {
      botpress.close();
    });
  };

  return {
    updateUser,
    openBotpress,
    closeBotpress,
  };
}
